import { CancelDiagnosisReport } from '~/domain/usecases/diagnosisReport/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteCancelDiagnosisReport implements CancelDiagnosisReport {
  private readonly url: string;

  private readonly httpClient: HttpClient<CancelDiagnosisReport.Model>;

  constructor(url: string, httClient: HttpClient<CancelDiagnosisReport.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  cancel = async (
    params: CancelDiagnosisReport.Params,
  ): Promise<CancelDiagnosisReport.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params?.report}/CANCEL`,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      default:
        throw new UnexpectedError();
    }
  };
}
